module.exports = __webpack_public_path__ + "img/logo-gama-cidadao.78473758.png";